"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitFromUnity = InitFromUnity;
exports.UnityResetScene = UnityResetScene;
exports.UnityLoadNextScene = UnityLoadNextScene;
exports.UnityLoadScene = UnityLoadScene;
const UnityLoaderSetup_1 = require("./UnityLoaderSetup");
const UnityTooltip_1 = require("../UI/UnityTooltip");
// Handles communication coming from Unity Object to page
function InitFromUnity() {
    // These should correspond to Unity SendMessage calls in the/JSLibs of the unity porject
    /** Scene Start handler: called from Unity
     * @param {string} str scene name, names of interactible objects
    */
    window.FromUnity_ApplicationStarted = function (str) {
        // store in global variable
        window.interactibleNames = Array.from(new Set(str
            .split(",")
            .map(name => name.trim())
            .filter(name => name.length > 0))).sort();
        // Initialize tooltip text with empty
        (0, UnityTooltip_1.UpdateTooltipText)("");
    };
    /** Unity SelectableObject broadcasts string `transform_name` on Select */
    window.FromUnity_Select = function (transform_name) {
        console.log("Selected: " + transform_name);
        // create event
        const event = new CustomEvent('UnityObjectSelected', { detail: { name: transform_name } });
        window.dispatchEvent(event);
    };
    window.FromUnity_Hover = function (transform_name) {
        //console.log("Hovered: " + transform_name);
        (0, UnityTooltip_1.UpdateTooltipText)(transform_name);
    };
}
// SendMessage Methods: calls to Unity 
// must be after UnityInstance is created and handled in the Unity code
function UnityResetScene() {
    // reloads active scene
    UnityLoaderSetup_1.UnityInstance.SendMessage('Main', 'ResetScene');
}
function UnityLoadNextScene() {
    UnityLoaderSetup_1.UnityInstance.SendMessage('Main', 'LoadNextScene');
}
function UnityLoadScene(n) {
    UnityLoaderSetup_1.UnityInstance.SendMessage('Main', 'LoadScene', n);
}
